/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import {
  FETCH_SD_EXTERNALUSER_APPLICATION_STATUS,
  FETCH_SD_USER_APPLICATION_INFO,
  SET_IEG_APPLICATION_TYPE,
} from './actionTypes';

/**
 * Updates the details in the 'SDApplication' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchSdExternaluserApplicationStatusReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_SD_EXTERNALUSER_APPLICATION_STATUS);

/**
 * Updates the indicator of creation of details in the 'SDApplication' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchSdExternaluserApplicationStatusReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_SD_EXTERNALUSER_APPLICATION_STATUS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchSdExternaluserApplicationStatusErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_SD_EXTERNALUSER_APPLICATION_STATUS);

/**
 * Updates the details in the 'SDApplication' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchSdUserApplicationInfoReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_SD_USER_APPLICATION_INFO);

/**
 * Updates the indicator of creation of details in the 'SDApplication' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchSdUserApplicationInfoReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_SD_USER_APPLICATION_INFO);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchSdUserApplicationInfoErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_SD_USER_APPLICATION_INFO);

/**
 * Updates the store with the new data.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const setIegApplicationTypeReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, { successAction: SET_IEG_APPLICATION_TYPE });

const reducers = combineReducers({
  fetchSdExternaluserApplicationStatus: fetchSdExternaluserApplicationStatusReducer,

  isFetchingFetchSdExternaluserApplicationStatus:
    isFetchingFetchSdExternaluserApplicationStatusReducer,
  fetchSdExternaluserApplicationStatusError: fetchSdExternaluserApplicationStatusErrorReducer,

  fetchSdUserApplicationInfo: fetchSdUserApplicationInfoReducer,

  isFetchingFetchSdUserApplicationInfo: isFetchingFetchSdUserApplicationInfoReducer,
  fetchSdUserApplicationInfoError: fetchSdUserApplicationInfoErrorReducer,

  iegApplicationType: setIegApplicationTypeReducer,
});

export default { reducers };
